namespace nsc {
    interface StatesDictionary {
        [abbreviation: string]: Readonly<string>;
    }

    export const states: StatesDictionary = {
        "AK": "Alaska",
        "AL": "Alabama",
        "AR": "Arkansas",
        "AZ": "Arizona",
        "CA": "California",
        "CO": "Colorado",
        "CT": "Connecticut",
        "DC": "District of Columbia",
        "DE": "Delaware",
        "FL": "Florida",
        "GA": "Georgia",
        "HI": "Hawaii",
        "IA": "Iowa",
        "ID": "Idaho",
        "IL": "Illinois",
        "IN": "Indiana",
        "KS": "Kansas",
        "KY": "Kentucky",
        "LA": "Luisiana",
        "MA": "Massachussets",
        "MD": "Maryland",
        "ME": "Maine",
        "MI": "Michigan",
        "MN": "Minnesota",
        "MO": "Missouri",
        "MS": "Mississippi",
        "MT": "Montana",
        "NC": "North Carolina",
        "ND": "North Dakota",
        "NE": "Nebraska",
        "NH": "New Hampshire",
        "NJ": "New Jersey",
        "NM": "New Mexico",
        "NV": "Nevada",
        "NY": "New York",
        "OH": "Ohio",
        "OK": "Oklahoma",
        "OR": "Oregon",
        "PA": "Pennsylvania",
        "RI": "Rhode Island",
        "SC": "South Carolina",
        "SD": "South Dakota",
        "TN": "Tennessee",
        "TX": "Texas",
        "UT": "Utah",
        "VA": "Virginia",
        "VT": "Vermont",
        "WA": "Washington",
        "WI": "Wisconsin",
        "WV": "West Virginia",
        "WY": "Wyoming"
    };

    jQuery.validator.addMethod("state", function (this: JQueryValidation.Validator, value: any, element: HTMLElement) {
        if (this.optional(element)) {
            return true;
        }

        value = value.toUpperCase();

        for (const abbreviation in states) {
            if (value === states[abbreviation].toUpperCase()) {
                return true;
            }
        }

        return false;
    });

    function matchState(query: string, callback: (matches: string[]) => void) {
        const matches: string[] = [];
        const pattern = new RegExp(query, "i");

        query = query.toUpperCase();

        for (const abbreviation in states) {
            const state = states[abbreviation];

            if (abbreviation === query) {
                callback([state]);
                return;
            }

            if (pattern.test(state)) {
                matches.push(state);
            }
        }

        callback(matches);
    }

    const typeaheadOptions: Twitter.Typeahead.Options = {
        hint: true,
        highlight: true,
        minLength: 1
    };

    const typeaheadDataset: Twitter.Typeahead.Dataset<string> = {
        name: "states",
        source: matchState
    };

    function stateTypeahead(this: HTMLElement) {
        const $input = $(this);

        $input.typeahead(typeaheadOptions, typeaheadDataset);

        $input.prev()
            .removeAttr("data-rule-state")
            .removeAttr("data-msg")
            .attr("aria-hidden", "true");
    };

    $("input[data-rule-state]").each(stateTypeahead);
}